import { useEffect, useRef } from 'react';
export function useConstant(factory) {
  var deps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var mountRef = useRef(false);
  var valueRef = useRef();

  if (!valueRef.current) {
    valueRef.current = factory();
  }

  useEffect(function () {
    if (!mountRef.current) {
      mountRef.current = true;
    } else {
      valueRef.current = factory();
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, deps);
  return valueRef.current;
}